/**
 * The theme registry (docs/design/theming.md). To add a theme: create
 * `./<id>.ts` exporting a `Theme`, and add it to `THEMES` below. Nothing else changes:
 * the provider turns it into CSS variables, the picker lists it, and the tests in
 * packages/ui check its tokens and contrast.
 */
import { calmCounter } from './calm-counter.js';
import { colourTiles } from './colour-tiles.js';
import { nightService } from './night-service.js';
import type { Theme } from './types.js';

export const THEMES: readonly Theme[] = [calmCounter, nightService, colourTiles];

export const DEFAULT_THEME_ID = calmCounter.id;
/** KDS terminals default to the dark, dense theme (theming.md, "Who chooses what"). */
export const DEFAULT_KDS_THEME_ID = nightService.id;

export function findTheme(id: string | null | undefined): Theme | undefined {
  return THEMES.find((t) => t.id === id);
}

export function getTheme(id: string | null | undefined): Theme {
  return findTheme(id) ?? (findTheme(DEFAULT_THEME_ID) as Theme);
}

export * from './types.js';
